import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { Box, Button } from "@mui/material";

interface FilterDisplayButtonProps {
  onClick: () => void;
  show: boolean;
  side?: "left" | "right";
}

const FilterDisplayButton = ({
  onClick,
  show,
  side = "left",
}: FilterDisplayButtonProps) => {
  const label = show ? "Hide Filter" : "Show Filter";

  const showLeftArrow = side === "left" ? show : !show;
  const Chevrons = showLeftArrow
    ? KeyboardDoubleArrowLeftIcon
    : KeyboardDoubleArrowRightIcon;

  return (
    <Button
      variant="contained"
      className="rounded-pill hide"
      onClick={onClick}
      sx={{ minWidth: "175px", color: "#000000de", my: 1 }}
    >
      <Box display="flex" justifyContent="space-evenly" flex={1}>
        <Chevrons />
        {label}
        <Chevrons />
      </Box>
    </Button>
  );
};
export default FilterDisplayButton;
